import React, { useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Students from './pages/Students';
import Applications from './pages/Applications';
import Tasks from './pages/Tasks';
import Payments from './pages/Payments';
import Reports from './pages/Reports';
import StudentProfile from './pages/StudentProfile';
import ApplicationProfile from './pages/ApplicationProfile';

import UserManagement from './pages/UserManagement';
import Countries from './pages/Countries';
import StudentClasses from './pages/StudentClasses';
import WorkingClasses from './pages/WorkingClasses';
import IELTSBooking from './pages/IELTSBooking';
import Profile from './pages/Profile';
import Attendance from './pages/Attendance';
import AttendanceHistory from './pages/AttendanceHistory';
import ClassManagement from './pages/ClassManagement';
import ExportStudents from './pages/ExportStudents';
import NoticeDetails from './pages/NoticeDetails';
import Notifications from './pages/Notifications';


const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user || user.role !== 'Admin') return <Navigate to="/" />;
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      
      <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="students" element={<Students />} />
        <Route path="students/:id" element={<StudentProfile />} />
        <Route path="student-classes" element={<StudentClasses />} />
        <Route path="working-classes" element={<WorkingClasses />} />
        <Route path="applications" element={<Applications />} />
        <Route path="applications/:id" element={<ApplicationProfile />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="payments" element={<Payments />} />
        <Route path="reports" element={<Reports />} />
        <Route path="users" element={<AdminRoute><UserManagement /></AdminRoute>} />
        <Route path="countries" element={<AdminRoute><Countries /></AdminRoute>} />
        <Route path="ielts" element={<IELTSBooking />} />
        <Route path="profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="attendance/:classId" element={<Attendance />} />
        <Route path="attendance/history/:studentId" element={<AttendanceHistory />} />
        <Route path="class-management" element={<ClassManagement />} />
        <Route path="export-students" element={<ExportStudents />} />
        <Route path="notices/:id" element={<NoticeDetails />} />
        <Route path="notifications" element={<Notifications />} />

        <Route path="*" element={<div className="p-8 text-center text-gray-500">Page under construction</div>} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppRoutes />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
